import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/not-found.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-icon">🔍</div>
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-message">
          Oops! The page you're looking for doesn't exist.
        </p>
        <p className="not-found-hint">
          It might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <Link to="/" className="not-found-button">
          Back to Home
        </Link>
      </div>
      
      {/* Decorative elements */}
      <div className="floating-404-elements">
        <div className="floating-element element-1">404</div>
        <div className="floating-element element-2">?</div>
        <div className="floating-element element-3">!</div>
        <div className="floating-element element-4">404</div>
      </div>
    </div>
  );
};

export default NotFound;
